import { createLead } from "./createLead";
import { deleteLead } from "./deleteLead";
import { getLeadId } from "./getLeadId";
import { getLeads } from "./getLeads";
import { handleLeadStatus } from "./handleLeadStatus";
import { updateLead } from "./updateLead";

export const leadsService = {
  getLeads,
  createLead,
  handleLeadStatus,
  getLeadId,
  deleteLead,
  updateLead,
};
